<template>
	<div id="classList">
		<div class="class-list" >
			<div class="class-item" v-for="(item,index) in bullClassData" :key="index" @click="getClassDetail(item)">
				<div class="sub_size">
					<img :src="item.ncNewBigImg" class="cover" alt="">
					<img src="../../assets/img/bull_class/fufei_2x.png" alt="" class="fu_fei" v-if="item.hasBuy == 0">
				</div>
				<div class="sub_001">
					<div class="bian_01">{{ item.ncName }}</div>
					<div class="bian_02">
						<div class="author">
							作者
							<span>({{ item.ncAuthor	}})</span>
						</div>
						<div class="create_time">
							{{ item.createTime }}								
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 买卡支付页 -->
		<el-dialog 
		:visible.sync="buyCardShow"
		:close-on-click-modal="false">
			<v-buyCard :liveDetailData="activeClassItem" :goodsType="0" ref="buyCard"></v-buyCard>
		</el-dialog>
	</div>
</template>
<script>
import vBuyCard from '../common/buy_card'
	
export default {
	name:"classList",
	data(){
		return {
			buyCardShow:false,
			activeClassItem:{},
		}
	},
	props:{
		bullClassData:{
			type:Array,
		}
	},
	watch:{
		
	},
	mounted() {
		
	},
	components:{
		'v-buyCard':vBuyCard,
	},
	methods:{
		//课程详情
		getClassDetail(item){
			//+------------------更新当前选中数据-------------
			this.activeClassItem = item;
			
			//+-----------------是否有观看权限----------------
			if(item.hasBuy == 0 || item.hasEnd == 0){
				//未购买或已到期
				this.$message.error({
					message:'暂无观看权限或权限已到期，请购买后观看',
					duration:1000,
					onClose:() => {
						this.buyCardShow = true;
					}
				});
				return false;
			}
			
			//+-----------------跳转课程详情-----------------
			this.$router.push({name:'classDetail',query:{ncId:item.ncId}});
		}
	}
}
</script>

<style scoped>
	.class-list{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	
	
   .class-item {
		background-color: #ffffff;
		margin-bottom: 20px;
		cursor: pointer;
		width: 352px;
		height: 342px;
		border-radius: 8px;
	}
	
	.sub_size {
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		position: relative;
	}
	
	.sub_size .cover{
		width: 320px;
		height: 180px;
		margin: 16px 16px 16px 16px;
		border-radius: 8px;
	}
	
	.sub_001 .bian_01{
		width: 320px;
		height: 80px;
		margin-left: 16px;
		margin-right: 16px;
		
		font-size: 20px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 28px;
	}
	
	.sub_001 .bian_02{
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
		display: flex;
		justify-content: space-between;
		margin-left: 16px;
		margin-right: 16px;
		margin-bottom: 32px;
	}
	
	
	
	.fu_fei {
		width: 51px;
		height: 31px;
		position: absolute;
		/* right: 16px;
		top: 0px; */
		
		right: 0px;
		top: -17px;
	}
	img {
		display: block;
		margin: auto;
	}
	
	.sub_001 p:nth-child(1) {
		color: #222222;
		font-size: 1.25rem;
		padding-top: 10px;
		overflow: hidden;
		/* height: 60px; */
		text-align: left;
		
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 1.75rem;
	}
	.sub_001 p:nth-child(2) {
		color: #666666;
		padding-bottom: 1.25rem;
		
		
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
	}	
</style>



// WEBPACK FOOTER //
// src/components/common/class_list.vue